import React from 'react'

import WindowLargeImage from './images/WindowLargeImage'

import './GalleryModal.scss'

const GalleryModal = ({ showModal, toggleModal, data }) => {
  if (showModal) {

    return (
      <div className="gallery-modal">
        <div className="gallery-modal__background" onClick={toggleModal} />
        <div className="gallery-modal__close" onClick={toggleModal}>
          Close
        </div>
        <div className="gallery-modal__content">
          <div className="gallery-modal__content__image" dangerouslySetInnerHTML={{__html: data.embed }} />
          <div className="gallery-modal__content__text">
            { data.caption }
          </div>
        </div>
      </div>
    )
  } else {
    return null
  }
}

export default GalleryModal
